var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.content
    ? _c(
        "div",
        [
          ["message", "error"].indexOf(_vm.content.type) >= 0
            ? _c("div", [
                _vm.content.type === "message"
                  ? _c("span", { staticClass: "alert alert-success d-block" }, [
                      _vm._v(_vm._s(_vm.content.message))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.content.type === "error"
                  ? _c("span", { staticClass: "alert alert-warning d-block" }, [
                      _vm._v(_vm._s(_vm.content.message))
                    ])
                  : _vm._e()
              ])
            : _c("b-card-body", [
                _vm.relationship === "BelongsToMany"
                  ? _c(
                      "div",
                      [
                        _c("multi-select-component", {
                          key: _vm.type,
                          attrs: {
                            type: _vm.content.type,
                            parent: _vm.parent,
                            selectedItems: _vm.content.data,
                            timestamp: _vm.timestamp,
                            schema: _vm.content.schema,
                            updateBatch: _vm.updateBatch,
                            onInitialized: _vm.onInitialized
                          }
                        })
                      ],
                      1
                    )
                  : _c(
                      "div",
                      [
                        _vm.contentType === "item"
                          ? _c("item-component", {
                              key: _vm.content.type + _vm.content.id,
                              attrs: {
                                timestamp: _vm.timestamp,
                                section: _vm.section,
                                type: _vm.content.type,
                                bindKeys: true,
                                id: _vm.content.id,
                                parent: _vm.parent,
                                attributes: _vm.content.attributes,
                                meta: _vm.content.meta,
                                schema: _vm.content.schema.attributes,
                                references: _vm.content.schema.refs,
                                resourceParams: _vm.resourceParams,
                                changeUrl: _vm.changeUrl,
                                changeSection: _vm.changeSection,
                                changeQuery: _vm.changeQuery,
                                haltFetch: _vm.haltFetch,
                                addNotification: _vm.addNotification,
                                commitQueue: _vm.commitQueue,
                                pushQueue: _vm.pushQueue,
                                createData: _vm.createData,
                                updateData: _vm.updateData,
                                deleteData: _vm.deleteData,
                                onInitialized: _vm.onInitialized,
                                onCreated: _vm.onCreated,
                                onChanged: _vm.onChanged,
                                onUpdated: _vm.onUpdated,
                                onDeleted: _vm.onDeleted
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.contentType === "collection"
                          ? _c("collection-component", {
                              key: _vm.type,
                              attrs: {
                                content: _vm.content,
                                parent: _vm.parent,
                                resourceParams: _vm.resourceParams,
                                timestamp: _vm.timestamp,
                                query: _vm.query,
                                section: _vm.section,
                                selected: _vm.selected,
                                createData: _vm.createData,
                                updateBatch: _vm.updateBatch,
                                deleteData: _vm.deleteData,
                                changeUrl: _vm.changeUrl,
                                changeSection: _vm.changeSection,
                                changeQuery: _vm.changeQuery,
                                addNotification: _vm.addNotification,
                                onCreating: _vm.onCreating,
                                onSelected: _vm.onSelected,
                                onInitialized: _vm.onInitialized
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
              ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-637e9568", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-637e9568","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/ContentViewComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-637e9568","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/ContentViewComponent.vue
// module chunks = 0